import type { FaireProductEntity } from "../../entity_types/product";

export const p_mjrf83nydx: FaireProductEntity = {
  token: "p_mjrf83nydx",
  type: "product",
  name: "25R84-A950 WIDE LEG FLARE PANTS WITH LACE INSERTS",
  brandToken: "b_dkldnd6ff4",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4fa699fe082abc74f52f93246b1348313f7932a5382c12b2464aaf8c81d714d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/74f74001cf16135d7cc67bd39388b14d8d583f9062ce10ac9d34c5539a146da6.jpeg",
    "https://cdn.faire.com/fastly/0a0251311d8138ecf181e68bc300137c703e6a95819348b6d6e1aa51b72f1fec.jpeg",
    "https://cdn.faire.com/fastly/989b7a7a941196a314b11b811ecd8d8e37e94fd1a9e6f4ecfa30697311d57a59.jpeg",
  ],
  priceDollars: 153.81,
  description:
    "Step into the world of boho-chic with Angie's 25R84-A950 Wide Leg Flare Pants. These pants embody a well-traveled, romantic spirit, featuring intricate lace inserts that add a touch of vintage elegance. The wide-leg flare cut is not only stylish but also ensures a comfortable and flattering fit. These pants are a true representation of Angie's commitment to creating bold, poetic, and instantly wearable clothing. Perfect for the woman who embraces a global lifestyle and isn't afraid of color or embellishment.",
  tags: [],
  msrpDollars: 307.62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:04.448Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
